import { apiRequestToken } from '../Utilidades/apiRequest';


export const getPermisosUsuario = async (usuarioid: string) => {
    return apiRequestToken({
        endpoint: `usuarios/${usuarioid}/workspace`,
        method: 'GET',
    })
};